<template>
<v-container>
  <FormPoint :form="form" :id="null" actionName="Créer" />

</v-container>
</template>
<script>
import FormPoint from '../forms/points';

export default {
  components: {FormPoint},
  data: () => ({
    form: {
      name_fr: '',
      contact: [],
       name: {fr: '', en: ''},
       description: {fr: '', en: ''},
       enabled: false,
       geocoord: {lat: null, lng: null},
       idSource: '',
       lastUpdate :'',
       location: {
         geoloc: {lat: null, lng: null},
         address: {city: '', country: 'France', streetAddress: '', zipcode: ''}
       },
       medias: [],
       openings: [],
       ot: '',
       value: 1,
       partner: '',
       range: 75,
       slug: '',
       typeValidation: 'gps',
       source: '',
       tags: []
      }
  }),
  methods: {

  }
}
</script>
